/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UpdateScheduleResponse {
    getFixupPrototypeFunction() { return UpdateScheduleResponse.fixupPrototype; }

    static newInstance(model: Partial<UpdateScheduleResponse>): UpdateScheduleResponse {
        let obj = Object.assign(new UpdateScheduleResponse(), model);
        UpdateScheduleResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UpdateScheduleResponse>): UpdateScheduleResponse {
        if (!model) return null;
        return UpdateScheduleResponse.newInstance(<UpdateScheduleResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UpdateScheduleResponse) {
        if (!obj) return;

        models.UpdateScheduleResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UpdateScheduleResponse): boolean {
        Object.setPrototypeOf(obj, UpdateScheduleResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Schedule ID
     */
    id: string;

}
